import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllContratoServicoUseCase } from "../../../presentation/useCases/read/get_all_contrato_servico_use_case";
import { ContratoServicoFilter } from "../../models/contrato_servico_filter";
import { ContratoServicoLista } from "../../models/contrato_servico_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


// GetAllContratoServicoServicoUseCase


export class GetAllContratoServicoUseCase
  extends BasePaginatedUseCase<ContratoServicoLista>
  implements IGetAllContratoServicoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemContratoServico(
    filter: ContratoServicoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemContratoServico(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
